import { Skeleton } from '@openedx/paragon';

/**
 * CountrySelectSkeleton component
 *
 * Low-fidelity skeleton loader for the country Form.Select field.
 * Matches the layout and structure of the actual country select field.
 */
export const CountrySelectSkeleton = () => (
  <div className="col-lg-6">
    <Skeleton width="35%" height={16} className="mb-2" />
    <Skeleton height={38} />
  </div>
);
